import { cities } from '@/api/template'
const state = {
  cities: [],
}

const mutations = {
  CHANGE_STATE: (state, value) => {
    Object.keys(value).map(key => {
      state[key] = value[key]
    })
  }
}

const actions = {
  changeCities({ commit }) {
    return new Promise(resolve => {
      cities().then(cities => {
        commit('CHANGE_STATE', { cities })
        resolve(cities)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
